module.exports = __webpack_public_path__ + "img/3-2.4a73badd.gif";